import { unknown } from 'valibot'

import {
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
  vString,
} from '../validation/index.ts'

export const loadEmailTypes = [
  'invoice-dispute',
  'load-change',
  'load-share',
  'load-out-for-delivery-share',
  'spot-quote-cancel',
  'spot-quote-uncancel',
  'spot-quote-lost',
  'spot-quote-message',
  'spot-quote-reject',
  'spot-quote-request',
  'spot-quote-response',
  'spot-quote-share',
  'spot-quote-tender-retract',
  'spot-quote-tender',
  'cancel',
  'pickup',
] as const
export type LoadEmailType = (typeof loadEmailTypes)[number]

export const renderEmailSchema = vObject({
  name: vString(),
  model: unknown(),
})

export type RenderEmailRequest = vOutput<typeof renderEmailSchema>

export interface RenderEmailResponse {
  html: string
}
export interface EmailListResponse {
  name: string
  model: Record<string, unknown>
}

export const renderLoadEmailSchema = vObject({
  type: vPicklist(loadEmailTypes),
  loadId: vObjectId(),
  args: vOptional(unknown()),
})

export type RenderLoadEmailRequest = vOutput<typeof renderLoadEmailSchema>

export interface LoadEmailListResponse {
  args: Record<string, unknown>
  type: LoadEmailType
}

export interface RenderLoadEmailResponse {
  html: string
  subject: string
}
